import React from 'react'

// The default is used on the server, the client should explictly override
// the value based on if it's hydrating or not
export const IsHydrating = React.createContext<boolean>(true)
